import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';
import { TAccountClientContact, TAccountClientContactPayloadParams, adaptAccountClientContactFromResponse } from 'src/store';

import { useAppSelector } from '../../hooks';
import { BACKEND_ACCOUNT_CLIENT } from '../../backend-paths';


export const accountClientContactDeleteApi = createAsyncThunk(
	`DELETE/${BACKEND_ACCOUNT_CLIENT}/:client_id/contacts/:id`,
	(payload: TAccountClientContactPayloadParams, thunkApi) => {
		const { id, clientId } = payload;
		const path = `${BACKEND_ACCOUNT_CLIENT}/${clientId}/contacts/${id}`;

		return HttpService.delete(path).then(result => {
			return adaptAccountClientContactFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

type TInitialState = {
	item?: TAccountClientContact,
	isLoading: boolean,
	error?: HttpError,
};

const initialState: TInitialState = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const accountClientContactDeleteSlice = createSlice({
	name: 'accountClientContactDeleteSlice',
	initialState,
	reducers: {
		clearAccountClientContactDelete(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[accountClientContactDeleteApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[accountClientContactDeleteApi.fulfilled.type]: (state, action: PayloadAction<TAccountClientContact>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[accountClientContactDeleteApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useAccountClientContactDeleteSelector = () => useAppSelector(state => state[accountClientContactDeleteSlice.name]);

export const { clearAccountClientContactDelete } = accountClientContactDeleteSlice.actions;
